import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import * as serviceWorker from "./serviceWorker.js"; // Typically not used in modern Vite setups unless specific need
import GA4React from "ga-4-react";
// import analytics from "react-segment"; // See note below about Segment
import { ThemeProvider } from "@material-tailwind/react";
import { PostHogProvider } from "posthog-js/react";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Access Vite environment variables
const posthogApiKey = import.meta.env.VITE_POSTHOG_KEY;
const posthogApiHost = import.meta.env.VITE_POSTHOG_HOST;
const isDevelopment = import.meta.env.DEV;

const options = {
  api_host: posthogApiHost,
};

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <PostHogProvider apiKey={posthogApiKey} options={options}>
        <App />
      </PostHogProvider>
    </ThemeProvider>
  </React.StrictMode>
);

//Setup GA tracking
try {
  setTimeout((_) => {
    // Ensure GA ID is handled correctly - could also be an env var
    const ga4react = new GA4React("G-7XSQGBSC2J");
    ga4react
      .initialize()
      .catch((err) => console.error("GA4 Initialization Error:", err));
  }, 4000);
} catch (err) {
  console.error("GA4 Setup Error:", err);
}

//Setup segment tracking

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://vite-pwa-org.netlify.app/ (if using VitePWA)
// The default serviceWorker.js from CRA might not be directly compatible or optimal with Vite.
// Vite has its own PWA plugin (vite-plugin-pwa) if you need PWA capabilities.
// For now, unregistering is fine if you don't intend to use it.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", function () {
    // Make sure the path to service-worker.js is correct if you intend to keep it.
    // Or remove this block if you're not using a service worker.
    navigator.serviceWorker
      .getRegistrations()
      .then(function (registrations) {
        for (let registration of registrations) {
          registration.unregister();
        }
      })
      .catch(function (err) {
        console.error("Service Worker unregistration failed: ", err);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
